<template>
  <div>
    <b-input-group>
      <b-form-input
        class="input input-search"
        placeholder="Buscar"
        v-on:keyup.enter="handleOnEnter"
        @change="change"
      />
      <b-input-group-append>
        <b-button class="pr-3 pl-3" @click="handleOnEnter">
          <b-icon icon="search" />
        </b-button>
      </b-input-group-append>
    </b-input-group>
  </div>
</template>

<script>
export default {
  name: 'InputSearch',
  props: {
    onEnter: {
      type: Function,
      default: () => {},
    },
  },
  methods: {
    handleOnEnter() {
      this.onEnter();
    },
    change(value) {
      this.$emit('input', value);
    },
  },
};
</script>
<style scoped>
.input {
  height: 44px;
}
.input-search {
  font-size: 1em;
  border-right: none;
}
.input-search:hover,
.input-search:active,
.input-search:focus {
  border: 2px solid #dedede !important;
  border-right: none !important;
}
.input-group-append > button {
  border: 2px solid #dedede !important;
  border-left: none !important;
  background-color: #ffff;
  height: 44px;
}
.input-group-append > button:active {
  background-color: #fff !important;
}
.input-group-append > button > svg {
  color: #848484;
}
</style>
